// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2EAo_","productName":"Table_productName__3Z3m4"};